import { render, staticRenderFns } from "./Bank.vue?vue&type=template&id=e5ece784&scoped=true&"
import script from "./Bank.vue?vue&type=script&lang=js&"
export * from "./Bank.vue?vue&type=script&lang=js&"
import style0 from "./Bank.vue?vue&type=style&index=0&id=e5ece784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ece784",
  null
  
)

export default component.exports